import { useRouter } from '@edreamsodigeo/frontend-core';
export const useGetItineraryParams = () => {
  const router = useRouter();
  const params = router.query['params'];
  const [leg, section] = params?.map(param => param.length === 1 ? param : null) || [];
  return leg ? {
    leg,
    section
  } : null;
};